import { TAppState } from '../../types/appState';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const hintQuestionsIsVisibleSelector = (state: TAppState): boolean => {
  const openChat = currentOpenChatSelector(state);

  return openChat?.hintQuestions?.isVisible || false;
};
